<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row v-if="dialogAdd === false">
          <v-col>
            <v-container>
              <template>
                <v-data-table
                  :headers="headers"
                  :items="desserts"
                  :items-per-page="30"
                  class="elevation-1"
                  hide-default-footer
                  disable-sort
                >
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="success"
                      dark
                      small
                      @click=";(dialogAdd = true), selectExchang(item)"
                      >เลือก
                    </v-btn>
                  </template>
                </v-data-table>
              </template>
            </v-container>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div style=" overflow-x: hidden" v-if="dialogAdd === true">
              <v-row style="padding:1% 2%; height: 100px;">
                <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                  <h2>เพิ่มเหรียญ</h2>
                </v-col>
                <v-col cols="12" xs="6" sm="6" md="6" lg="6" class="displayxs">
                  <v-btn
                    @click=";(dialogAdd = false), clear()"
                    large
                    color="primary"
                    >ยกเลิก</v-btn
                  >
                </v-col>
              </v-row>
              <v-divider style="padding-top:0; magin: 0px 0px"></v-divider>
              <v-container>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-row style="padding-top: 20px;">
                    <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                      <v-row>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                          <h3>
                            1. กรอกข้อมูล (
                            <span style="color: red;">*</span> จำเป็น )
                            และกดปุ่มตรวจสอบ
                          </h3>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="padding-colH"
                        >
                          <p style="margin: 0px 0px">
                            สินค้า/บริการ <span style="color: red;">*</span>
                          </p>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          style="padding:0px 0px"
                        >
                          <v-text-field
                            v-model="productExchangeRate"
                            solo
                            readonly
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="padding-colH"
                          v-if="chkFGF === false"
                        >
                          <p style="margin: 0px 0px">
                            จำนวนเหรียญ <span style="color: red;">*</span>
                          </p>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          style="padding:0px 0px"
                          v-if="chkFGF === false"
                        >
                          <v-text-field
                            v-model="formAdd.amount"
                            label="จำนวนเงิน (บาท)"
                            type="number"
                            :min="0"
                            solo
                            readonly
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="padding-colH"
                          v-if="chkFGF === true"
                        >
                          <p style="margin: 0px 0px">
                            จำนวนเหรียญ <span style="color: red;">*</span>
                          </p>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          style="padding:0px 0px"
                          v-if="chkFGF === true"
                        >
                          <v-select
                            v-model="formAdd.amount"
                            label="จำนวนเหรียญ"
                            :items="FgF"
                            solo
                            :rules="[rules.required]"
                            required
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="padding-colH"
                        >
                          <p style="margin: 0px 0px">
                            เบอร์โทรศัพท์ <span style="color: red;">*</span>
                          </p>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          style="padding:0px 0px"
                        >
                          <v-text-field
                            v-model="formAdd.tel"
                            label="เบอร์โทรศัพท์"
                            v-mask="'###-###-####'"
                            solo
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="padding-colH"
                          v-if="session.data.userTypeGroup !== 'Operation'"
                        >
                          <p style="margin: 0px 0px">
                            สาขา <span style="color: red;">*</span>
                          </p>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          style="padding:0px 0px"
                        >
                          <v-select
                            v-model="formAdd.masBranchID"
                            label="สาขา"
                            solo
                            :items="dataBranch"
                            :rules="[rules.required]"
                            :menu-props="{ bottom: true, offsetY: true }"
                            required
                          ></v-select>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          style="padding:0px 0px"
                          v-if="session.data.userTypeGroup === 'Operation'"
                        >
                          <v-select
                            v-model="formAdd.masBranchID"
                            label="สาขา"
                            solo
                            readonly
                            :items="dataBranch"
                            :rules="[rules.required]"
                            :menu-props="{ bottom: true, offsetY: true }"
                            required
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="padding-colH"
                        >
                          <p style="margin: 0px 0px">เลขอ้างอิง</p>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          style="padding:0px 0px"
                        >
                          <v-text-field
                            v-model="formAdd.refId"
                            label="เลขอ้างอิง"
                            solo
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="padding-colH"
                          style="padding-bottom: 8%"
                        >
                          <v-btn
                            block
                            large
                            color="primary"
                            @click="
                              ;(confirmBtn = false), validate(), addData()
                            "
                            >ตรวจสอบ
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                      <v-row>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                          <h3>
                            2.ตรวจสอบข้อมูลลูกค้า และกดปุ่ม
                            <span style="color: #25D252;">เพิ่มเหรียญ</span>
                          </h3>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                          <v-card max-width="460">
                            <v-row v-if="formProfile.memberId === ''">
                              <v-col class="text-center">
                                <h2>ตรวจสอบข้อมูลลูกค้า</h2>
                              </v-col>
                            </v-row>
                            <v-col class="text-center">
                              <v-avatar color="primary" size="150">
                                <img
                                  :src="
                                    formProfile.picture !== ''
                                      ? formProfile.picture
                                      : 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'
                                  "
                                  alt="John"
                                />
                              </v-avatar>
                              <v-card-title class="text-h5">
                                <v-col class="text-center">
                                  {{
                                    formProfile.name
                                      ? formProfile.name
                                      : 'สมชาย สีสะอาด'
                                  }}
                                </v-col>
                              </v-card-title>
                            </v-col>

                            <v-row>
                              <v-col class="text-center"
                                >เหรียญคงเหลือ :
                                {{
                                  formProfile.point
                                    ? formatNumber(formProfile.point)
                                    : '-'
                                }}</v-col
                              >
                            </v-row>
                            <v-divider
                              style="padding-top:0; magin: 0px 0px"
                            ></v-divider>
                            <v-container>
                              <v-row>
                                <v-col class="text-start" style="color:#4a4a4a"
                                  >ชื่อ-สกุล</v-col
                                >
                                <v-col class="text-end">{{
                                  formProfile.nameCustomer
                                    ? formProfile.nameCustomer
                                    : '-'
                                }}</v-col>
                              </v-row>
                              <v-row>
                                <v-col class="text-start" style="color:#4a4a4a"
                                  >เบอร์โทรศัพท์</v-col
                                >
                                <v-col
                                  class="text-end"
                                  v-mask="'###-###-####'"
                                  >{{
                                    formProfile.tel ? formProfile.tel : '-'
                                  }}</v-col
                                >
                              </v-row>
                              <v-row>
                                <v-col class="text-start" style="color:#4a4a4a"
                                  >ระดับ</v-col
                                >
                                <v-col class="text-end">{{
                                  formProfile.LevelName
                                    ? formProfile.LevelName
                                    : '-'
                                }}</v-col>
                              </v-row>
                            </v-container>

                            <v-card-text v-if="blockAddCoin">
                              <v-alert
                                type="warning"
                                dense
                                text
                                border="left"
                                class="mb-0"
                              >
                                บัญชีนี้ยังไม่ได้อัปเดตข้อมูลกรุณาให้ลูกค้าอัปเดตข้อมูลให้เรียบร้อย
                                จากนั้นกดตรวจสอบอีกครั้งจึงจะแจกเหรียญได้
                              </v-alert>
                            </v-card-text>
                            <v-card-text v-else>
                              <v-row>
                                <v-col></v-col>
                                <v-col></v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="#f74569"
                                dark
                                @click="
                                  ;(dialog = false), (confirmBtn = true)
                                  //   reset(),
                                  clearProfile(),
                                    getProductExchangeRate(),
                                    getDataBranch()
                                "
                                v-if="formProfile.memberId !== ''"
                              >
                                ยกเลิก
                              </v-btn>
                              <v-btn
                                color="#25D252"
                                :loading="loading"
                                :disabled="loading"
                                @click="confirm(), confirm === true"
                                v-if="formProfile.memberId !== '' && !blockAddCoin"
                              >
                                เพิ่มเหรียญ
                              </v-btn>
                              <!-- <v-btn
                                class="ma-2"
                                :loading="loading"
                                :disabled="loadingStatus"
                                color="secondary"
                                @click="confirm()"
                              >
                                Accept Terms
                              </v-btn> -->
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>

              <!-- <v-dialog v-model="dialogReCheck" persistent max-width="490">
            </v-dialog> -->
            </div>
          </v-col>
        </v-row>

        <v-row>
          <!-- confirm member -->
          <v-dialog
            v-model="dialogPhoneNumber"
            persistent
            max-width="550px"
            :fullscreen="$vuetify.breakpoint.mobile"
          >
            <v-card
              class="text-center v-card-chk"
              style="height:545px"
            >
              <v-col class="text-right">
                <v-btn
                  outlined
                  small
                  fab
                  color="teal"
                  @click="
                    dialogPhoneNumber = false
                    dialogAdd = true
                  "
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-avatar
                class="avatar"
                size="150"
                style="box-shadow: 0px 18px 40px rgba(112, 144, 176, 0.12); padding: 10px 10px;"
              >
                <img alt="user" :src="this.dataFilterTel.picture" />
              </v-avatar>
              <v-col>
                <h2
                  style="color: #1B2559; font-family: Kanit !important ; font-size: 35px !important;font-style: normal;font-weight: 700;"
                >
                  ยืนยันข้อมูล
                </h2>
              </v-col>
              <v-row>
                <v-col cols="12">
                  <h3
                    style="color: #A3AED0; font-family: Kanit !important ; font-size: 25px !important;"
                    v-if="dataFilterTel.nameCustomer"
                  >
                    {{ dataFilterTel.nameCustomer }}
                  </h3>
                  <h3
                    style="color: #A3AED0; font-family: Kanit !important ; font-size: 25px !important;"
                    v-else
                  >
                    {{ dataFilterTel.name }}
                  </h3>
                  <h3
                    style="color: #A3AED0; font-family: Kanit !important ; font-size: 25px !important;"
                  >
                    {{ dataFilterTel.tel }}
                  </h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="text-center divBtn">
                    <v-btn
                      style="width: 240px; padding-top: 9px;"
                      rounded
                      color="#20C92F"
                      x-large
                      dark
                      @click="conF"
                      ><h6
                        style="font-family: Kanit !important ;font-size: 20px !important;"
                      >
                        บันทึกข้อมูล
                      </h6>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-dialog>
          <!-- <AddCoin  /> -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'
import AddCoin from '../Master/AddCoin.vue'

// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    AddCoin
  },
  // created () {
  //   setInterval(this.getNowGlobal, 1000)
  // },
  data () {
    return {
      headers: [
        { text: 'ประเภทการเข้ารับบริการ', value: 'label' },
        { text: 'จำนวนค่าใช้จ่ายก่อน Vat', value: 'desc' },
        { text: 'ได้รับเหรียญ', value: 'con' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      desserts: [
        {
          label: 'ตรวจเช็กระยะ',
          desc: 'ไม่จำกัดค่าใช้จ่าย',
          con: '100 เหรียญ / บริการ 1 ครั้ง'
        },
        {
          label: 'ซ่อมทั่วไป',
          desc: '100 - 2,000 บาท',
          con: '50 เหรียญ / บริการ 1 ครั้ง'
        },
        {
          label: 'ซ่อมทั่วไป',
          desc: '2,001 บาท ขึ้นไป',
          con: '100 เหรียญ / บริการ 1 ครั้ง'
        },
        {
          label: 'ซ่อมตัวถังและสี',
          desc: '1,000 - 5,000 บาท',
          con: '50 เหรียญ / บริการ 1 ครั้ง'
        },
        {
          label: 'ซ่อมตัวถังและสี',
          desc: '5,001 บาท ขึ้นไป',
          con: '100 เหรียญ / บริการ 1 ครั้ง'
        },
        {
          label: 'เปลี่ยนแบตเตอรี่',
          desc: 'ลูกค้าเปลี่ยนแบตเตอรี่ ได้รับ 200 เหรียญ',
          con: '200 เหรียญ / เปลี่ยน'
        },
        {
          label: 'ออกรถคันใหม่',
          desc: 'ตามราคารุ่นรถยนต์ Honda ทุกรุ่น',
          con: '1,000 เหรียญ / 1 คัน'
        },
        {
          label: 'ซื้อประกันภัย',
          desc: '10,000 - 15,000 บาท',
          con: '300 เหรียญ / กรมธรรม์'
        },
        {
          label: 'ซื้อประกันภัย',
          desc: '15,001 บาท ขึ้นไป',
          con: '500 เหรียญ / กรมธรรม์'
        },
        {
          label: 'กิจกรรมพิเศษ',
          desc: 'CSI.Survey / Booking',
          con: '100 เหรียญ'
        },
        // {
        //   label: 'HAPPY DAY HAPPY DRIVE',
        //   desc:
        //     'ลูกค้าเข้ามาเทสต์ไดรฟ์รถและจองรถยนต์ใหม่ ตั้งแต่วันที่ 1 ธ.ค. 65 - 31 ม.ค. 66',
        //   con: '500 เหรียญ'
        // },
        {
          label: 'Friend get Friend',
          desc: 'ค่าแนะนำให้คะแนนตามระดับ',
          con: '10,000 - 30,000 เหรียญ'
        },
        {
          label: 'New Code 4',
          desc: 'สำหรับลูกค้าใหม่',
          con: '1,000 เหรียญ'
        },
        {
          label: 'Paysave',
          desc: 'Paysave(eTax)',
          con: '1,000 เหรียญ'
        },
        {
          label: 'เพื่อนแนะนำเพื่อนงานบริการ',
          desc: 'เพื่อนแนะนำเพื่อนงานบริการ',
          con: '2,000 เหรียญ'
        },
        {
          label: 'โปรพิเศษตรวจเช็กระยะ 500 เหรียญ / บริการ 1 ครั้ง',
          desc: '-',
          con: '500 เหรียญ'
        },
        {
          label: 'โปรพิเศษ 2,000 เหรียญ / บริการ 1 ครั้ง',
          desc: '-',
          con: '2,000 เหรียญ'
        },
        {
          label: 'โปรพิเศษ 9.9 / บริการ 1 ครั้ง',
          desc: '-',
          con: '999 เหรียญ'
        }
        // {
        //   label: 'Retention Sunday',
        //   desc: 'ลูกค้าที่จะเข้าวันอาทิตย์',
        //   con: '500 เหรียญ'
        // }
        // {
        //   label: 'ซ่อมทั่วไป (9 - 31 พ.ค. 68)',
        //   desc: '100 -  2,001 บาท ขึ้นไป',
        //   con: '1,000 เหรียญ'
        // },
        // {
        //   label: 'ซ่อมตัวถังและสี (9 - 31 พ.ค. 68)',
        //   desc: '1,000 - 5,001 บาท ขึ้นไป',
        //   con: '1,000 เหรียญ'
        // },
        // {
        //   label: 'ซื้อประกันภัย (9 - 31 พ.ค. 68)',
        //   desc: '10,000 - 15,001 บาท ขึ้นไป',
        //   con: '1,000 เหรียญ'
        // },
        // {
        //   label: 'ออกรถคันใหม่ (9 - 31 พ.ค. 68)',
        //   desc: 'ตามราคารุ่นรถยนต์ Honda ทุกรุ่น',
        //   con: '2,000 เหรียญ'
        // }
      ],
      panel: [0, 1, 2, 3],
      session: this.$session.getAll(),
      dialogAdd: false,
      valid: true,
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      loadingAdd: true,
      validAdd: true,
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      formAdd: {
        productExchangeRateId: '',
        amount: 0,
        refId: '',
        token: '',
        status: 'waiting',
        statusMemberCard: 'collect',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        masBranchID: '',
        branchName: '',
        CREATE_DATE: '',
        tel: ''
      },
      formProfile: {
        picture: '',
        name: '',
        tel: '',
        point: '',
        totalpoint: '',
        LevelName: '',
        nameCustomer: '',
        memberId: '',
        lineUserIdNewProvider: ''
      },
      providerCheckAllShops: false,
      providerCheckShopIds: [
        'SHOP_20260218130804572123',
        'Uc520945108b983b6e739ed0a8cd8dae4'
      ],
      dataBranch: [],
      dataMember: [],
      loading: false,
      dialogPhoneNumber: false,
      ProductExchangeRate: [],
      Branch: '',
      productExchangeRate: '',
      dataFilterTel: {
        nameCustomer: '',
        tel: '',
        name: '',
        picture: ''
      },
      mobile: false,
      dateNow: new Date(Date.now() - new Date().getTimezoneOffset() * 30000)
        .toISOString()
        .substr(0, 10),
      FgF: [
        { text: '5,000', value: '5000' },
        { text: '10,000', value: '10000' },
        { text: '20,000', value: '20000' },
        { text: '30,000', value: '30000' }
      ],
      confirmBtn: true,
      cancelBtn: false,
      chkFGF: false,
      // loader: null,
      //   loading: false,
      loadingStatus: false
    }
  },
  computed: {
    providerCheckEnabled () {
      return (
        this.providerCheckAllShops ||
        this.providerCheckShopIds.indexOf((this.session.data || {}).shopId) !==
          -1
      )
    },
    memberNotMigrated () {
      return (
        this.formProfile.memberId !== '' &&
        !String(this.formProfile.lineUserIdNewProvider || '').trim()
      )
    },
    blockAddCoin () {
      return this.providerCheckEnabled && this.memberNotMigrated
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    console.log(this.dateNow)
    // await this.getMember()
    await this.getDataBranch()
  },
  methods: {
    // getMember () {
    //   this.dataMember = []
    //   axios
    //     .get(this.DNS_IP + '/member/get?shopId=' + this.session.data.shopId)
    //     .then(response => {
    //       let rs = response.data
    //       console.log('dataMem', rs)
    //       if (rs.status === false) {
    //         this.dataMember = []
    //       } else {
    //         this.dataMember = rs
    //         console.log('dataMem', this.dataMember)
    //       }
    //     })
    // },
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchID
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
          console.log(this.dataBranch)
          if (this.dataBranch.length === 1) {
            this.formAdd.masBranchID = s.value
            this.formAdd.branchName = s.text
            console.log('masBranch', this.formAdd.masBranchID)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    selectExchang (exchange) {
      console.log('session', this.session.data)
      if (exchange.label === 'ตรวจเช็กระยะ') {
        console.log('label', exchange.label)
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 251
        this.formAdd.amount = 100
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        } else {
          this.formAdd.masBranchID = ''
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'ซ่อมทั่วไป') {
        if (exchange.desc === '100 - 2,000 บาท') {
          console.log(exchange.label)
          this.productExchangeRate = exchange.label
          this.formAdd.productExchangeRateId = 255
          this.formAdd.amount = 50
          if (this.$session.getAll().data.userTypeGroup === 'Operation') {
            this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
            this.Branch = this.$session.getAll().data.masBranchName
          }
          this.formAdd.shopId = this.$session.getAll().data.shopId
        } else {
          this.productExchangeRate = exchange.label
          this.formAdd.productExchangeRateId = 252
          this.formAdd.amount = 100
          if (this.$session.getAll().data.userTypeGroup === 'Operation') {
            this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
            this.Branch = this.$session.getAll().data.masBranchName
          }
          this.formAdd.shopId = this.$session.getAll().data.shopId
        }
      } else if (exchange.label === 'ซ่อมตัวถังและสี') {
        if (exchange.desc === '1,000 - 5,000 บาท') {
          this.productExchangeRate = exchange.label
          this.formAdd.productExchangeRateId = 256
          this.formAdd.amount = 50
          if (this.$session.getAll().data.userTypeGroup === 'Operation') {
            this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
            this.Branch = this.$session.getAll().data.masBranchName
          }
          this.formAdd.shopId = this.$session.getAll().data.shopId
        } else {
          this.productExchangeRate = exchange.label
          this.formAdd.productExchangeRateId = 253
          this.formAdd.amount = 100
          if (this.$session.getAll().data.userTypeGroup === 'Operation') {
            this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
            this.Branch = this.$session.getAll().data.masBranchName
          }
          this.formAdd.shopId = this.$session.getAll().data.shopId
        }
      } else if (exchange.label === 'เปลี่ยนแบตเตอรี่') {
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 263
        this.formAdd.amount = 200
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'ออกรถคันใหม่') {
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 165
        this.formAdd.amount = 1000
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'ซื้อประกันภัย') {
        if (exchange.desc === '10,000 - 15,000 บาท') {
          this.productExchangeRate = exchange.label
          this.formAdd.productExchangeRateId = 243
          this.formAdd.amount = 300
          if (this.$session.getAll().data.userTypeGroup === 'Operation') {
            this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
            this.Branch = this.$session.getAll().data.masBranchName
          }
          this.formAdd.shopId = this.$session.getAll().data.shopId
        } else {
          this.productExchangeRate = exchange.label
          this.formAdd.productExchangeRateId = 218
          this.formAdd.amount = 500
          if (this.$session.getAll().data.userTypeGroup === 'Operation') {
            this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
            this.Branch = this.$session.getAll().data.masBranchName
          }
          this.formAdd.shopId = this.$session.getAll().data.shopId
        }
      } else if (exchange.label === 'กิจกรรมพิเศษ') {
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 257
        this.formAdd.amount = 100
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'Friend get Friend') {
        this.chkFGF = true
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 258
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'New Code 4') {
        // this.chkFGF = true
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 270
        this.formAdd.amount = 1000
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'HAPPY DAY HAPPY DRIVE') {
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 264
        this.formAdd.amount = 500
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'Paysave') {
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 271
        this.formAdd.amount = 1000
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'Retention Sunday') {
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 277
        this.formAdd.amount = 500
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'เพื่อนแนะนำเพื่อนงานบริการ') {
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 278
        this.formAdd.amount = 2000
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'โปรพิเศษตรวจเช็กระยะ 500 เหรียญ / บริการ 1 ครั้ง') {
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 284
        this.formAdd.amount = 500
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'โปรพิเศษ 2,000 เหรียญ / บริการ 1 ครั้ง') {
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 286
        this.formAdd.amount = 2000
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      } else if (exchange.label === 'โปรพิเศษ 9.9 / บริการ 1 ครั้ง') {
        this.productExchangeRate = exchange.label
        this.formAdd.productExchangeRateId = 287
        this.formAdd.amount = 999
        if (this.$session.getAll().data.userTypeGroup === 'Operation') {
          this.formAdd.masBranchID = this.$session.getAll().data.masBranchID
          this.Branch = this.$session.getAll().data.masBranchName
        }
        this.formAdd.shopId = this.$session.getAll().data.shopId
      }
      console.log('add', this.formAdd)
    },
    searchTel () {},
    // async addData () {
    //   let tel = this.formAdd.tel
    //     .split('-')
    //     .join('')
    //     .trim()
    //   await axios
    //     .get(
    //       this.DNS_IP +
    //         '/member/get?shopId=' +
    //         this.session.data.shopId +
    //         '&tel=' +
    //         tel
    //     )
    //     .then(async response => {
    //       let data = []
    //       if (response.data.status === false) {
    //         this.$swal(
    //           'ไม่พบบัญชีผู้ใช้',
    //           'กรุณาตรวจสอบหมายเลขโทรศัพท์',
    //           'error'
    //         )
    //       } else {
    //         data = response.data
    //         this.dialogPhoneNumber = true
    //         this.dialogAdd = false

    //         console.log('dtM22', data)
    //         this.dataFilterTel.nameCustomer = data[0].nameCustomer
    //         this.dataFilterTel.name = data[0].name
    //         this.dataFilterTel.tel = data[0].tel
    //         this.dataFilterTel.picture = data[0].picture
    //       }
    //       this.dataMember = response.data
    //       console.log(this.dataMember)
    //       await this.dataMember
    //     })
    // },
    conF () {
      this.$swal({
        title: 'ต้องการให้คะแนนด้วยเบอร์โทรศัพท์ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(result => {
        var data = {
          refId: this.formAdd.refId,
          shopId: this.$session.getAll().data.shopId,
          tel: this.formAdd.tel
            .split('-')
            .join('')
            .trim(),
          Amount: this.formAdd.amount,
          exchangRateId: this.formAdd.productExchangeRateId.toString(),
          masBranchID: this.formAdd.masBranchID,
          masBranchName: this.formAdd.branchName,
          branchName: this.Branch,
          User: this.session.data.displayName,
          source: false
        }
        console.log('data', data)
        axios.post(this.DNS_IP + '/POSapi', data).then(response => {
          console.log('POSapi"', response)
          if (response.data.status === 'เลขอ้างอิงนี้แจกเหรียญไปแล้ว') {
            this.$swal('เลขอ้างอิงนี้ซ้ำ', 'กรุณาตรวจสอบเลขอ้างอิง', 'error')
          } else {
            this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          }
        })
        this.clearData()
        this.dialogPhoneNumber = false
        this.dialogAdd = false
        this.dataReady = true
      })
    },
    async clearData () {
      this.Exchange = ''
      this.formAdd.productExchangeRateId = ''
      this.formAdd.amount = 0
      this.formAdd.point = 0
      this.formAdd.token = ''
      this.formAdd.status = 'waiting'
      this.formAdd.statusMemberCard = 'collect'
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.formAdd.qrCodeURL = ''
      this.formAdd.branchName = ''
      this.formAdd.masBranchID = ''
      this.formAdd.CREATE_DATE = ''
      this.formAdd.CREATE_DATE = ''
      this.formAdd.tel = ''
      this.formAdd.refId = ''
    },
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    addData () {
      console.log(this.$refs.form.validate())

      if (this.$refs.form.validate() === true) {
        axios
          .get(
            this.DNS_IP +
              '/member/get?shopId=' +
              this.session.data.shopId +
              '&tel=' +
              this.formAdd.tel
                .split('-')
                .join('')
                .trim()
          )
          .then(result => {
            if (result.data.status === false) {
              this.$swal(
                'ไม่พบบัญชีผู้ใช้',
                'กรุณาตรวจสอบหมายเลขโทรศัพท์',
                'error'
              )
              this.confirmBtn = true
              this.clearProfile()
            } else {
              this.profile = true
              if (result.data[0].pictures !== '') {
                this.formProfile.picture = result.data[0].picture
              } else {
                this.formProfile.picture =
                  'https://cdn.vuetifyjs.com/images/cards/cooking.png'
              }
              this.formProfile.picture = result.data[0].picture
              this.formProfile.name = result.data[0].name
              this.formProfile.tel = result.data[0].tel
              this.formProfile.point = result.data[0].currentPoint
              this.formProfile.totalPoint = result.data[0].collectPoint
              this.formProfile.LevelName = result.data[0].LevelName
              this.formProfile.nameCustomer = result.data[0].nameCustomer
              this.formProfile.memberId = result.data[0].memberId
              this.formProfile.lineUserIdNewProvider =
                result.data[0].lineUserIdNewProvider || ''
              console.log(result.data)
            }
          })
      }
    },
    async confirm () {
      this.loadingStatus = true
      this.loading = true
      let masbranchName = this.dataBranch.filter(
        a => this.formAdd.masBranchID === a.value
      )
      var data = {
        refId: this.formAdd.refId,
        shopId: this.$session.getAll().data.shopId,
        tel: this.formAdd.tel
          .split('-')
          .join('')
          .trim(),
        Amount: this.formAdd.amount,
        exchangRateId: this.formAdd.productExchangeRateId.toString(),
        masBranchID: this.formAdd.masBranchID,
        masBranchName: masbranchName[0].text,
        branchName: this.Branch,
        User: this.session.data.displayName,
        source: false
      }
      console.log('dad', data)
      axios.post(this.DNS_IP + '/POSapi', data).then(response => {
        console.log('POSapi"', response.data.message)
        if (response.data.message === 'เลขอ้างอิงนี้แจกเหรียญไปแล้ว') {
          this.$swal('เลขอ้างอิงนี้ซ้ำ', 'กรุณาตรวจสอบเลขอ้างอิง', 'error')
          this.loadingStatus = false
          this.loading = false
        } else if (response.data && response.data.status === false) {
          this.$swal('ไม่สามารถแจกเหรียญได้', response.data.message, 'error')
          this.loadingStatus = false
          this.loading = false
        } else {
          this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          this.loadingStatus = false
          this.loading = false

          this.clear()
          this.reset()
          this.dialogAdd = false
          this.getProductExchangeRate()
          this.getDataBranch()
          this.loading = true
        }
      })
    },
    clear () {
      this.formAdd.productExchangeRateId = ''
      this.formAdd.amount = ''
      this.formAdd.tel = ''
      this.formAdd.masBranchID = ''
      this.formAdd.refId = ''
      this.formAdd.point = ''
      this.formAdd.token = ''
      this.formAdd.status = 'waiting'
      this.formAdd.statusMemberCard = 'collect'
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = this.session.data.shopId
      this.formAdd.qrCodeURL = ''
      this.formAdd.CREATE_DATE = ''
      this.formProfile.picture = ''
      this.formProfile.name = ''
      this.formProfile.tel = ''
      this.formProfile.point = ''
      this.formProfile.totalPoint = ''
      this.formProfile.LevelName = ''
      this.formProfile.nameCustomer = ''
      this.formProfile.memberId = ''
      this.formProfile.lineUserIdNewProvider = ''
      this.chkFGF = false
    },
    clearProfile () {
      this.formProfile.picture = ''
      this.formProfile.name = ''
      this.formProfile.tel = ''
      this.formProfile.point = ''
      this.formProfile.totalPoint = ''
      this.formProfile.LevelName = ''
      this.formProfile.nameCustomer = ''
      this.formProfile.memberId = ''
      this.formProfile.lineUserIdNewProvider = ''
    }
  }
}
</script>
<style scope>
.padding-colH {
  padding: 5px 15px 0px;
}
.v-text-field {
  padding: 16px 16px 0px !important;
}
.red {
  color: red;
}
.displayxs {
  display: grid;
  justify-content: end;
}
</style>



// WEBPACK FOOTER //
// src/components/Core/VGroupShortcuts.vue